import { Close } from '@mui/icons-material'
import Modal from 'react-modal'
import { formatDateTimeInUruguay } from './utils'

export default function UserRatings({ ratingsVisible, setRatingsVisible, reviews }) {
  const formatUruguayDateString = value => {
    try {
      const { time, dayName, day, monthName, year } = formatDateTimeInUruguay(value)
      return `${dayName} ${day} ${monthName} ${year} ${time}`
    } catch (e) {
      return ''
    }
  }

  const getScore = r => {
    const value = r?.qualification ?? r?.score ?? r?.rating
    const num = Number(value)
    return isNaN(num) ? null : num
  }

  const scores = Array.isArray(reviews) ? reviews.map(getScore).filter(v => v !== null) : []
  const average = scores.length ? scores.reduce((a, b) => a + b, 0) / scores.length : 0

  const getDateMs = r => {
    const raw = r?.date || r?.created || r?.created_at
    const ms = raw ? new Date(raw).getTime() : 0
    return isNaN(ms) ? 0 : ms
  }
  const sortedReviews = Array.isArray(reviews)
    ? [...reviews].sort((a, b) => getDateMs(b) - getDateMs(a))
    : []

  const openUserInNewTab = userId => {
    if (!userId) return
    const url = `${window.location.origin}?navigation=UserSearch&user_id=${encodeURIComponent(
      userId
    )}`
    window.open(url, '_blank')
  }
  const customStyles = {
    content: {
      borderRadius: '1.5rem',
      marginTop: 'auto',
      marginBottom: 'auto',
      paddingLeft: '1.6rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    overlay: {
      zIndex: 90,
      backgroundColor: 'rgba(0,0,0,0.5)'
    }
  }

  return (
    <Modal
      isOpen={ratingsVisible}
      onRequestClose={() => setRatingsVisible(false)}
      style={customStyles}
    >
      <div className='flex flex-col h-full'>
        <div className='flex justify-end mb-4'>
          <Close onClick={() => setRatingsVisible(false)} />
        </div>
        {Array.isArray(reviews) && (
          <div className='flex mb-3'>
            <p className='font-bold text-lg'>
              {average.toFixed(1)} - {reviews.length} calificaciones
            </p>
          </div>
        )}
        {Array.isArray(reviews) && reviews.length > 0 ? (
          <ol className='overflow-auto h-[calc(100vh-10rem)]'>
            {sortedReviews.map((rating, index) => (
              <li key={rating.id || rating._id || index} className='mb-4'>
                <div className='border border-gray rounded-xl p-4 dark:border-dk-border'>
                  <div
                    className='flex items-center gap-3 mb-2 cursor-pointer hover:opacity-80'
                    onClick={() => openUserInNewTab(rating.reviewer?.user_id)}
                    role='button'
                    tabIndex={0}
                    onKeyDown={e =>
                      (e.key === 'Enter' || e.key === ' ') &&
                      openUserInNewTab(rating.reviewer?.user_id)
                    }
                  >
                    {rating.reviewer?.picture && (
                      <img
                        src={rating.reviewer.picture}
                        alt={rating.reviewer?.name || 'Usuario'}
                        className='w-8 h-8 rounded-full object-cover'
                      />
                    )}
                    <div className='flex flex-col'>
                      <span className='font-semibold'>
                        {rating.reviewer?.name + ' - ' + rating.reviewer?.user_id}
                      </span>
                      {(rating.date || rating.created || rating.created_at) && (
                        <span className='text-xs text-gray dark:text-gray-400'>
                          {formatUruguayDateString(
                            rating.date || rating.created || rating.created_at
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                  <p className='font-bold mb-1'>{rating.qualification.toFixed(1)}</p>
                  {rating.text && <p className='text-base text-gray-700 dark:text-gray-300'>{rating.text}</p>}
                </div>
              </li>
            ))}
            <li className='text-xl text-center mb-4'>FIN</li>
          </ol>
        ) : (
          <div className='flex justify-center'>
            <p>No hay calificaciones</p>
          </div>
        )}
      </div>
    </Modal>
  )
}
